// Default gate schedule structure
export const DEFAULT_GATE_SCHEDULE = {
    monday: { enabled: false, start: '', end: '' },
    tuesday: { enabled: false, start: '', end: '' },
    wednesday: { enabled: false, start: '', end: '' },
    thursday: { enabled: false, start: '', end: '' },
    friday: { enabled: false, start: '', end: '' },
    saturday: { enabled: false, start: '', end: '' },
    sunday: { enabled: false, start: '', end: '' }
};

